import React from 'react';

const field = (value) => String(value ?? '').trim();
const numeric = (value) => value === null || value === undefined || field(value) === '' ? null : Number(value);
const result = (row) => {
  const value = field(row.WinLose || row.Result).toUpperCase();
  if (value === 'W' || value === 'WIN') return 'WIN';
  if (value === 'L' || value === 'LOSS' || value === 'LOSE') return 'LOSS';
  return null;
};

const EvidenceResultRow = ({ row, metric }) => {
  const opponent = field(row.EnemyTeam || row.VS);
  const pf = numeric(row.PF);
  const pa = numeric(row.PA);
  const value = metric ? numeric(row[metric]) : null;
  const outcome = result(row);
  return <li className="v2-evidence-row">
    <div className="v2-evidence-row-main">
      <time>{field(row.Date) || 'Date unavailable'}</time>
      <strong>{metric ? field(row.Player) || 'Player unavailable' : opponent ? `vs ${opponent}` : 'Opponent unavailable'}</strong>
      <span>{[field(row.Mode), field(row.Map), field(row.MatchType)].filter(Boolean).join(' / ') || 'Match details unavailable'}</span>
    </div>
    <div className="v2-evidence-row-result">
      {metric ? <strong>{value === null || !Number.isFinite(value) ? '-' : `${metric} ${value.toFixed(1)}`}</strong> : <>
        {outcome && <b className={outcome === 'WIN' ? 'win' : 'loss'}>{outcome}</b>}
        {pf !== null && pa !== null && Number.isFinite(pf) && Number.isFinite(pa) && <span>{pf}-{pa}</span>}
      </>}
    </div>
  </li>;
};

export default EvidenceResultRow;
